import {EventEmitter, Injectable} from '@angular/core';
import {ToolsService} from '../../../tools/tools.service';
import {BehaviorSubject, from, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import * as _ from 'lodash';
import {PanierService} from '../../../manage/panier/panier.service';


import {BaseclientService} from '../../../apiclient/baseclient.service';
import {DialogsService} from "../../../manage/dialogs/dialogs.service";

@Injectable({
  providedIn: 'root'
})
export class FulleStockService {

  // Premiere initialisation ?
  public isInitStocks : boolean = false;

  // Liste des stocks en cours
  public stocks: any = {};

  //TODO voir pour rendre cela plus propre
  private copystocks: any = {}
  private arrayPop = [];
  private copyPopstocks: any = {}

  private currStock: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    private tools: ToolsService,
    private currentPanier: PanierService,
    private baseClient: BaseclientService,
    private dialogService: DialogsService
  ) {
  }

  displayAlertStockDialog(setPageLoaderEvent: EventEmitter<any> | null = null, forceStocks: boolean = false): Promise<any> {
    return new Promise((resolve) => {
      let flag = true;
      let promise;
      // On force une nouvelle récupération de stocks
      if (forceStocks || !this.isInitStocks)
      {
        // console.log("ici");
        promise = this.getStocks().toPromise();
      }
      // On récupére déja les stocks existants
      else
        promise = Promise.resolve(this.stocks)

      promise.then(
        (data) => {
          if (data.length > 0 && this.getArrayPop().length > 0) {
            this.dialogService.openAlertStockDial(this.getArrayPop());
            flag = false;
          }
          if (setPageLoaderEvent != null)
            setPageLoaderEvent.emit(false);
          resolve({
            data: flag,
          });
        },
        (error) => {
          console.error('err', error);
          if (setPageLoaderEvent != null) {
            setPageLoaderEvent.emit(false);
          }
        }
      );
    });
  }

  /**
   * @description Récupère la liste de tous les produits avec stock + le stock (Utile pour récupèrer les stocks de produit de formule)
   * @return {Promise}
   */
  getStocks(): Observable<any> {
    const params = {
      buying_mode: 1
    };
    return from(this.baseClient.postBaseApi("stocks", params))
      .pipe(
        map(data => {
          // console.log("stock.service - getStocks - data : ", data);
          const currPanier = this.tools.getStor(PanierService.TAG_STORAGE);
          if (data.list.length > 0) {
            this.initStocks(data.list, currPanier);
          } else {
            // si array vide et currPanier
            if (currPanier) {
              //on remove le stock du basket
              this.managePanier(currPanier, true);
            }
          }
          return this.stocks;
        })
      )
  }

  /**
   * @description Met à jour le stock
   * @param stocks
   * @param panier
   * @return
   */
  private initStocks(stocks: any[], panier?: any): void {

    // Tableau associatif des stocks
    let newParsedStocks : any = {};

    // Création du tableau associatif
    for (let i = 0; i < stocks.length; i++) {
      newParsedStocks[(stocks[i].id_product).toString()] = {
        count: stocks[i].stock,
      };
    }

    this.stocks = newParsedStocks;
    // Premiere initialisation OK
    this.isInitStocks = true;

    //TODO pourquoi faire ?
    this.copystocks = _.cloneDeep(this.stocks);

    //TODO pourquoi faire ?
    this.copyPopstocks = _.cloneDeep(this.stocks)

    if (panier) {

      // on control et on modifie
      this.managePanier(panier, false);
    }
  }

  /**
   * @description Retourne le stock d'un produit
   * @param {number} prodId
   *
   */
  getProdStock(prodId: number) {

    return this.stocks[prodId.toString()];
  }

  /**
   * @description modifie les stocks du panier
   * @param panier
   * @param removeStock efface les stock
   */
  managePanier(panier: any, removeStock: boolean = false) {

    // Parcours du panier
    panier.map((prod: any) => {

      // Suppression du stock
      if (removeStock) {
        this.resetPanierStock(prod)
      } else {
        this.checkProdStock(prod, prod.quantity)
      }

      if (prod.details && prod.details.length > 0) {

        prod.details.map((prodDetails: any) => {
          if (removeStock) {
            this.resetPanierStock(prodDetails)
          } else {
            this.checkProdStock(prodDetails, prod.quantity)
          }
        });

        this.ManStockFormuledisplay(prod, 'panier');
      }
    });

    //si stock
    if (this.stocks) {
      this.updateStockinpos();
      this.controlstock();
    }

    this.currentPanier.setCurrentBasket(panier, 'updateStock');
  }

  /**
   * @description modifie les stocks du panier
   * @param {any} panier
   * @param {any} remove efface les stock
   *
   */
  checkProdStock(prod: any, quantity: any) {
    this.getProdStock(prod.id) ? this.UpdateStock(prod, quantity) : this.resetPanierStock(prod);
  }

  /**
   * @description update les stocks
   * @param {any} prod
   * @param {any} quantity
   */

  UpdateStock(prod: any, quantity: any) {


    this.stocks[prod.id.toString()].count -= quantity;

    prod.stock = this.stocks[prod.id.toString()];
    this.copystocks[prod.id.toString()] = _.cloneDeep(this.stocks[prod.id.toString()]);

    if (prod.details) {

      prod.details.map((det: any) => {
        if (det.stock) {
          this.stocks[det.id.toString()].count -= quantity;


          this.copystocks[det.id.toString()] = _.cloneDeep(this.stocks[det.id.toString()]);
        }
        det.stock = this.stocks[det.id.toString()];

      })

    }


  }

  /**
   * @description efface les stocks du panier
   * @param {any} prod
   */
  resetPanierStock(prod: any) {
    prod.stock = null;
    if (prod.has_stock) {
      prod.has_stock = null;
    }
  }

  /**
   * @description Set le nouveau stock d'un produit
   * @param {number} prodId
   * @param {number} prodQuantity
   */
  handleProdStock(prodId: number, prodQuantity: number, action: string, newcount?: any) {


    if (action === "add") {


      if (newcount) {


        this.stocks[prodId.toString()].newcount += prodQuantity;
        this.stocks[prodId.toString()].count = this.stocks[prodId.toString()].newcount >= 0 ? this.stocks[prodId.toString()].newcount : 0;
      } else {

        this.stocks[prodId.toString()].count += prodQuantity;

      }


    } else if (action === "remove") {


      if (newcount) {

        this.stocks[prodId.toString()].newcount -= prodQuantity;
        this.stocks[prodId.toString()].count = this.stocks[prodId.toString()].newcount > 0 ? this.stocks[prodId.toString()].newcount : 0;

      } else {

        this.stocks[prodId.toString()].count -= prodQuantity;


      }


    }


    //affichage des stock produit rubric soit actualisé
    this.setCurrStock(prodId, this.stocks[prodId.toString()].count);


    return this.stocks[prodId.toString()].count;
  }

  /**
   * @description display modif formule si 1
   * @param {any} prodFormule
   */
  ManStockFormuledisplay(prodFormule: any, panier?: any) {

    if (!panier) {
      prodFormule.categories.map((cat: any) => {
        cat.details.map((det: any) => {
          if (det.product.stock) {
            prodFormule.has_stock = true;
            prodFormule.maxQuantityRest = 0;
          }
        })
      })
    } else {

      for (let i = 0; i < prodFormule.details.length; i++) {
        let det = prodFormule.details[i];
        prodFormule.has_stock = null;
        if (det.stock) {
          prodFormule.has_stock = true;
          prodFormule.maxQuantityRest = 0;
          break
        }
      }
    }
  }


  /**
   * @description remet le stock a 0 si negatif
   */
  updateStockinpos() {

    let arr_stocks = new Array(this.stocks);

    Object.keys(arr_stocks[0]).map(function (k) {
      if (arr_stocks[0][k].count < 0) {

        arr_stocks[0][k].newcount = _.cloneDeep(arr_stocks[0][k].count);
        arr_stocks[0][k].count = 0;
      }

      return arr_stocks[0][k];
    });

  }

  /**
   * @description control le stock si negatif pop up
   */
  controlstock() {

    let arr_copystocks = new Array(this.copystocks);

    let ArrayPopup: any = [];
    Object.keys(arr_copystocks[0]).map(function (k) {
      if (arr_copystocks[0][k].count < 0) {

        let variables = {
          id: Number(k),
          count: arr_copystocks[0][k].count
        }
        ArrayPopup.push(variables);
      }
    });

    if (ArrayPopup.length > 0) {
      this.infoProd(ArrayPopup);
    }
  }

  /**
   * @description getArrayPop stock negatif
   */
  getArrayPop() {
    return this.arrayPop;
  }

  /**
   * @description set ArrayPop stock negatif ou []
   */
  setArrayPop(ArrayPopup: any) {
    this.arrayPop = ArrayPopup;
  }

  /**
   * @description info du produit
   */
  infoProd(ArrayPopup: any) {
    const currPanier = this.tools.getStor(PanierService.TAG_STORAGE);


    ArrayPopup.map((det: any) => {

      for (let i = 0; i < currPanier.length; i++) {
        let item = currPanier[i];

        if (det.id === item.id) {
          det.image = item.image
          det.name = item.name;
        }

        if (item.categories && item.categories.length > 0 && item.details.length > 0) {

          for (let j = 0; j < item.details.length; j++) {
            let itemDetails = item.details[j];
            if (det.id === itemDetails.id) {
              det.image = itemDetails.image
              det.name = itemDetails.name;
            }
          }
        }
      }

    })

    this.popQtyProd(ArrayPopup);
  }

  /**
   * @description quantité du produit à supprimer pop
   */
  popQtyProd(ArrayPopup: any) {
    let array: any = [];

    ArrayPopup.map((det: any) => {
      if (det.count < 0 && det.name) {
        let count = Math.abs(this.copyPopstocks[(det.id).toString()].count);
        let newcount = Math.abs(this.copystocks[(det.id).toString()].count);
        det.count = newcount - count;
        array.push(det);
      }
    })

    this.setArrayPop(array);
  }

  // Return the Observable of the current Stock
  getCurrStock(): Observable<any> {
    return this.currStock.asObservable();
  }

  //set the current Stock
  setCurrStock(id: any, count: any): void {
    let value: any = {id: id, count: count};
    this.currStock.next(value);
  }

}




